import React from 'react';
import Dispatcher from '../dispatchers/Dispatcher';

/**
 * Outcome modal for custom events and configurable buttons that track outcome.
 * Mirrors BattleOutcomeModal's Won/Lost/Draw choices, but writes the result to the
 * event's `outcome` field (via the `tracked-outcome-modal-click` action) and has no
 * battle-specific side effects.
 */
export default class TrackedOutcomeModal extends React.Component {
    save(outcome) {
        Dispatcher.dispatch({
            type: 'tracked-outcome-modal-click',
            data: {
                outcome: outcome,
                time: this.props.time
            }
        });
    }

    render() {
        // Draw is not a valid outcome for custom events (only Battle keeps it).
        const isCustom = this.props.lockedEvent && this.props.lockedEvent.type === 'custom';

        return (
            <div className={`modal-overlay team ${this.props.open ? 'open' : ''}`}>
                <div className="modal-content">
                    <div className="section">
                        <h1>Select Outcome</h1>
                        <div className="btn-row-6-stack">
                            <div className="btn" onClick={() => this.save('won')}>
                                <span>WON</span>
                            </div>
                            <div className="btn" onClick={() => this.save('lost')}>
                                <span>LOST</span>
                            </div>
                            {!isCustom &&
                                <div className="btn" onClick={() => this.save('draw')}>
                                    <span>DRAW</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
